// Toggle on click
document.addEventListener('click', function (e) {
	const btn = e.target.closest('.accordion-text-widget .bordo-div');
	if (!btn) return;

	const wrapper = btn.closest('.accordion-text-widget');
	const contentWrapper = wrapper.querySelector('.accordion-content-wrapper');
	const expanded = btn.getAttribute('aria-expanded') === 'true';

	if (expanded) {
		contentWrapper.style.maxHeight = '13px';
	} else {
		contentWrapper.style.maxHeight = contentWrapper.scrollHeight + 'px';
	}

	btn.setAttribute('aria-expanded', !expanded);
});

// Ensure accordions are opened by default on mobile (max-width: 768px)
function updateAccordionForWrapper(wrapper, isMobile) {
	const btn = wrapper.querySelector('.bordo-div');
	const contentWrapper = wrapper.querySelector('.accordion-content-wrapper');
	if (!btn || !contentWrapper) return;

	if (isMobile) {
		// open on mobile by default
		contentWrapper.style.maxHeight = contentWrapper.scrollHeight + 'px';
		btn.setAttribute('aria-expanded', 'true');
	} else {
		// keep existing state if user toggled, otherwise default to closed (13px)
		const expanded = btn.getAttribute('aria-expanded') === 'true';
		if (expanded) {
			contentWrapper.style.maxHeight = contentWrapper.scrollHeight + 'px';
		} else {
			contentWrapper.style.maxHeight = '13px';
			btn.setAttribute('aria-expanded', 'false');
		}
	}
}

function updateAllAccordions() {
	const isMobile = window.matchMedia('(max-width: 768px)').matches;
	document.querySelectorAll('.accordion-text-widget').forEach(function (wrapper) {
		updateAccordionForWrapper(wrapper, isMobile);
	});
}

// Debounce helper for resize
function debounce(fn, wait) {
	let t;
	return function () {
		clearTimeout(t);
		t = setTimeout(fn, wait);
	};
}

// Initialize on load
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', updateAllAccordions);
} else {
	updateAllAccordions();
}

// Update on resize (debounced)
window.addEventListener('resize', debounce(updateAllAccordions, 150));





// WEBPACK FOOTER //
// ./js/widget/accordion-text.js